/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SecurityEventType {
    SPLIT = 'SPLIT',
    REVERSE_SPLIT = 'REVERSE_SPLIT',
    ADJUST = 'ADJUST',
    CONVERSION = 'CONVERSION',
}
